import { call, put, select, takeLatest } from "redux-saga/effects";

import type { FiChartSummary } from "@mapmycustomers/shared/types/entity/fieldInsight";
import Organization from "@mapmycustomers/shared/types/Organization";
import ListResponse from "@mapmycustomers/shared/types/viewModel/ListResponse";

import { callApi } from "@app/store/api/callApi";
import { handleError } from "@app/store/errors/actions";
import { getOrganizationId } from "@app/store/iam/selectors";

import { fetchFieldInsightsChartSummary, updateFieldInsightsChartSummary } from "./actions";

function* onFetchFieldInsightsChartSummary({
  payload,
}: ReturnType<typeof fetchFieldInsightsChartSummary>) {
  try {
    const orgId: Organization["id"] = yield select(getOrganizationId);
    const response: ListResponse<FiChartSummary> = yield callApi(
      "fetchFieldInsightsChartSummary",
      orgId
    );
    yield call(payload.callback, response.data);
  } catch (error) {
    yield put(handleError({ error }));
    if (payload.failureCallback) {
      yield call(payload.failureCallback);
    }
  }
}

function* onUpdateFieldInsightsChartSummary({
  payload,
}: ReturnType<typeof updateFieldInsightsChartSummary>) {
  try {
    const orgId: Organization["id"] = yield select(getOrganizationId);
    const response: FiChartSummary = yield callApi(
      "updateFieldInsightsChartSummary",
      orgId,
      payload.tableId,
      payload.data
    );
    yield call(payload.callback, response);
  } catch (error) {
    yield put(handleError({ error }));
    if (payload.failureCallback) {
      yield call(payload.failureCallback);
    }
  }
}

export function* fieldInsightsChartSummarySaga() {
  yield takeLatest(fetchFieldInsightsChartSummary, onFetchFieldInsightsChartSummary);
  yield takeLatest(updateFieldInsightsChartSummary, onUpdateFieldInsightsChartSummary);
}
